import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { classes } from "typestyle";
import { ReactComponent as TwoLogo } from "../../assets/illustrations/two.svg";
import { ReactComponent as NetsLogo } from "../../assets/illustrations/nets2.svg";
import { ReactComponent as MasterCardLogo } from "../../assets/illustrations/mastercard.svg";
import { ReactComponent as VisaLogo } from "../../assets/illustrations/visa.svg";
import { ReactComponent as Vipps } from "../../assets/illustrations/vipps_footer.svg";
import { ReactComponent as Klarna } from "../../assets/illustrations/klarna.svg";
import { ReactComponent as Logo } from "../../assets/logo-black.svg";
import { ReactComponent as SmallLogo } from "../../assets/small-logo-black.svg";
import { ReactComponent as IconUser } from "../../assets/icons/icon_user.svg";
import { ReactComponent as IconTicket } from "../../assets/icons/icon_ticket.svg";
import { ReactComponent as IconKey } from "../../assets/icons/icon_key.svg";
import * as styles from "./styles";
import Trustpilot from "../Trustpilot";

const ExternalLink: React.FC<{ href: string; children?: React.ReactNode }> = (props) => (
  <a target="_blank" rel="noopener noreferrer" href={props.href}>
    {props.children}
  </a>
);

const Footer: React.FC = () => {
  const intl = useIntl();
  return (
    <div className={styles.footer} data-nosnippet>
      <div className={styles.hooplaPromotion}>
        <SmallLogo height={20} />
        <span>
          <FormattedMessage
            id="components.Footer.soldWith"
            defaultMessage="Tickets to this event are sold with"
          />{" "}
          <ExternalLink href="https://www.hoopla.no/arranger/?utm_source=sales_pages&utm_medium=sold_by_strip">
            <FormattedMessage
              id="components.Footer.hooplaTicket"
              defaultMessage="Hoopla Ticket System"
            />
          </ExternalLink>
        </span>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.logoAndLinks}>
            <div className={styles.brand}>
              <a
                href="https://www.hoopla.no/?utm_source=sales_pages&utm_medium=footer_logo"
                aria-label={intl.formatMessage({
                  id: "components.Footer.linkToPortal",
                  defaultMessage: "Link to Hoopla portal",
                })}
              >
                <Logo height={32} />
              </a>
              <div style={{ margin: "0.5rem 0 0.5rem -0.25rem" }}>
                <iframe
                  title="Status"
                  src="https://status.hoopla.no/badge?theme=light"
                  width="250"
                  height="30"
                  style={{ border: 0 }}
                />
              </div>
            </div>
            <div className={classes(styles.box, styles.links)}>
              <ExternalLink href="/organizer">
                <IconKey height="12" />
                <FormattedMessage
                  id="components.Footer.loginForOrganizer"
                  defaultMessage="Login for organizer"
                />
              </ExternalLink>
              <ExternalLink href="https://my.hoopla.no">
                <IconUser height="12" />
                <FormattedMessage id="components.Footer.myPage" defaultMessage="My Page" />
              </ExternalLink>
              <ExternalLink href="https://www.hoopla.no/arranger/?utm_source=sales_pages&utm_medium=footer_link">
                <IconTicket height="10" />
                <FormattedMessage
                  id="components.Footer.sellTickets"
                  defaultMessage="Sell tickets with Hoopla"
                />
              </ExternalLink>
            </div>
          </div>
          <div className={styles.checkoutsAndStuff}>
            <div className="flex flex-col gap-y-4">
              <div className={classes(styles.paymentMethods)}>
                <NetsLogo />
                <Vipps />
                <Klarna />
                <VisaLogo />
                <MasterCardLogo />
                <a aria-label="Hva er Two?" href="https://www.two.inc/no/resources/buyers">
                  <TwoLogo />
                </a>
              </div>
              <Trustpilot />
            </div>
            <div>
              <div className={classes(styles.box, styles.hooplaInfo)}>
                Hoopla AS, Sorgenfriveien 9, 7031 Trondheim <br></br> Orgnr 997 312 368 MVA
              </div>
              <div className={styles.termsAndPrivacy}>
                <ExternalLink href="https://www.hoopla.no/arranger/vilkar-billettkjopere/">
                  <FormattedMessage
                    id="components.Footer.terms"
                    defaultMessage="Terms for ticket buyers"
                  />
                </ExternalLink>
                <ExternalLink href="https://www.hoopla.no/arranger/avbestillingsforsikring/">
                  <FormattedMessage
                    id="components.Footer.cancellationInsurance"
                    defaultMessage="Cancellation insurance"
                  />
                </ExternalLink>
                <ExternalLink href="https://www.hoopla.no/arranger/personvern/">
                  <FormattedMessage id="components.Footer.privacy" defaultMessage="Privacy" />
                </ExternalLink>
                <ExternalLink href="https://www.hoopla.no/arranger/tilgjengelighet/">
                  <FormattedMessage
                    id="components.Footer.accessibility"
                    defaultMessage="Accessibility statement"
                  />
                </ExternalLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
